import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Some air particles are colored in blue (left) and the equation above illustrates that a pressure difference between the two sides leads to an acceleration and thus a displacement of the particles. The orange rectangle (right) is fixed and the equation above illustrates that an amount of air enters into this volume, causes an increase in mass and thus an increase in density, since the volume is fixed.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0102/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
